// An email ready to send, as a mailto: link (0036). No imports, so the message builders and their tests can use
// it on their own. The server has the same rule (functions/lib/message-by.ts EMAIL_RULE).

// One plain mailbox: nothing that could add to a mailto: link (?, &, commas, spaces).
export const EMAIL_RULE = /^[A-Za-z0-9._+'-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/

// Line breaks go as %0A, as the enquiry emails always have; mail apps read them as new lines.
export function mailtoHref(raw: string | null | undefined, subject: string, body: string): string | null {
  const addr = String(raw ?? '').trim()
  if (!EMAIL_RULE.test(addr)) return null
  return `mailto:${addr}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}

export function gmailHref(raw: string | null | undefined, subject: string, body: string): string | null {
  const addr = String(raw ?? '').trim()
  if (!EMAIL_RULE.test(addr)) return null
  return `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(addr)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}

// Accept either form because editable customer messages replace their link as the owner types.
export function emailLinks(href: string): { gmail: string; mailto: string } | null {
  try {
    const url = new URL(href)
    const mail = url.protocol === 'mailto:'
    if (!mail && (url.origin !== 'https://mail.google.com' || url.pathname !== '/mail/')) return null
    const addr = mail ? decodeURIComponent(url.pathname) : url.searchParams.get('to')
    const subject = url.searchParams.get(mail ? 'subject' : 'su') ?? ''
    const body = url.searchParams.get('body') ?? ''
    const gmail = gmailHref(addr, subject, body), mailto = mailtoHref(addr, subject, body)
    return gmail && mailto ? { gmail, mailto } : null
  } catch { return null }
}
